import React, { useCallback } from "react";
import { GET } from "../../../utils/axios";
import { ReusableHistoryViewer } from "../../../components/History";

const ORDER_HISTORY_ENTITY_LABELS = {
  order: "Order",
  equipment: "Equipment",
  shipment: "Shipment",
  consignee_shipper: "Consignee / Shipper",
  master_load: "Master Load",
  stops: "Stops",
  rates: "Rates",
  documents: "Documents",
  notes: "Notes",
};

export default function OrderHistory({ controlNumber, locationNumber }) {
  const fetchOrderHistoryPage = useCallback(
    async (page, size) => {
      const res = await GET(
        `history/location/${locationNumber}/orders/${controlNumber}/?page=${page}&size=${size}`,
      );

      if (res?.httpCode === 200 && res?.status === "success") {
        return {
          history: Array.isArray(res?.data?.history) ? res.data.history : [],
          pagination: res?.data?.pagination,
        };
      }

      return {
        history: [],
        pagination: { hasMore: false },
      };
    },
    [controlNumber, locationNumber],
  );

  return (
    <ReusableHistoryViewer
      fetchHistoryPage={fetchOrderHistoryPage}
      reloadKey={`${controlNumber}-${locationNumber}`}
      title="Order History Search"
      entityLabels={ORDER_HISTORY_ENTITY_LABELS}
      initialExpandedGroups={2}
      pageSize={20}
    />
  );
}
